/**
 * ARCHX AI — File Intake Service
 * Notifies the ARCHX team (via the Cloudflare worker) when a dentist or lab
 * sends files through the public /send page. Best-effort: failures are ignored
 * so they never block the upload.
 */

const NOTIFY_URL = 'https://archxai.io/api/intake-notify';

export async function notifyIntake(submission) {
  const res = await fetch(NOTIFY_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id:          submission.id,
      senderName:  submission.senderName,
      senderEmail: submission.senderEmail,
      practice:    submission.practice,
      caseRef:     submission.caseRef,
      notes:       submission.notes,
      fileCount:   (submission.files || []).length,
      fileNames:   (submission.files || []).map(f => f.name),
    }),
  });
  return res.ok;
}
